import React from "react";
import * as cl from "../MainInfo/MainInfo.module.scss";
import ChooseSelect from "../ChooseSelect";
import LockedContent from "../LockedContent";
import Enroll from "../Enroll";
import CourseItem from "../CourseItem";

const MainInfoExtra = ({
  state,
  meta: { title, has_access, access, upgrade_url },
  name,
  currentBlockName,
  changeSelect,
  locked,
  enroll,
  onNoAccessClick,
  onEnroll,
}) => {
  if (locked && !enroll) {
    return (
      <div className={cl.wrapper}>
        <h1 className={cl.title} dangerouslySetInnerHTML={{ __html: title }} />
        <LockedContent link={upgrade_url} />
      </div>
    );
  }

  if (currentBlockName === undefined)
    return (
      <div className={cl.wrapper}>
        <h1 className={cl.title}> {title}</h1>
      </div>
    );

  const currentLessonBlock = Object.values(state).find(
    (el) => el.title === currentBlockName
  );

  // For lessons with topics debugging
  // const currentLessonBlock = {lessons: state}

  if (currentLessonBlock.lessons) {
    return (
      <div className={cl.wrapper}>
        <h1 className={cl.title} dangerouslySetInnerHTML={{ __html: title }} />

        {!enroll && (
          <ChooseSelect
            state={state}
            access={access}
            currentBlockName={currentBlockName}
            changeSelect={changeSelect}
            onNoAccessClick={onNoAccessClick}
          />
        )}

        {enroll && (
          <Enroll
            name={name}
            hasAccess={has_access}
            access={access}
            onEnroll={onEnroll}
            onNoAccessClick={onNoAccessClick}
          />
        )}

        <div className={cl.lessons}>
          {Object.values(currentLessonBlock.lessons).map((lesson, index) => {
            return (
              <React.Fragment key={lesson.id}>
                {lesson.topics && !!lesson.topics.length && (
                  <div>
                    <h2
                      className={cl.lessons__title}
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        columnGap: "10px",
                      }}
                    >
                      <span className={cl.lessons__count}>{index + 1}.</span>

                      {lesson.title}
                    </h2>
                  </div>
                )}

                <ul className={cl.lessons_list}>
                  {lesson.topics && lesson.topics.length === 0 && (
                    <li onClick={() => {                      
                      // actid=13
                      window.analytics?.track("object:click", {
                        "object": "lesson",
                        "course_title": name,
                        "topic_title": title,
                        "title": lesson.title,
                        "parent_object_title": title,
                        "url": window.location.href
                      });
                    }}>
                      <CourseItem
                        count={index + 1}
                        isTitle={lesson.topics && lesson.topics.length === 0}
                        item={lesson}
                        onNoAccessClick={onNoAccessClick}
                      />
                    </li>
                  )}
                  {lesson.topics &&
                    lesson.topics.length > 0 &&
                    lesson.topics.map((topic) => {
                      return (
                        <li className={cl.lessons__lesson} key={topic.id}>
                          <CourseItem
                            item={topic}
                            onNoAccessClick={onNoAccessClick}
                          />
                        </li>
                      );
                    })}
                </ul>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    );
  }

  const isHaveTopics = currentLessonBlock.topics?.length > 0;

  return (
    <div className={cl.wrapper}>
      <h1 className={cl.title} dangerouslySetInnerHTML={{ __html: title }} />

      {!enroll && (
        <ChooseSelect
          state={state}
          currentBlockName={currentBlockName}
          changeSelect={changeSelect}
          onNoAccessClick={onNoAccessClick}
        />
      )}

      {enroll && (
        <Enroll
          name={name}
          hasAccess={has_access}
          access={access}
          onEnroll={onEnroll}
          onNoAccessClick={onNoAccessClick}
        />
      )}

      <div className={cl.lessons}>
        <h2 className={cl.lessons__title}>
          <span className={cl.lessons__count}>1.</span>
          {currentLessonBlock.title}
        </h2>

        <ul className={cl.lessons_list}>
          {/* if we haven't topics then duplicate parent */}
          {isHaveTopics ? (
            currentLessonBlock.topics.map((topic) => (
              <li className={cl.lessons__lesson} key={topic.id}>
                <CourseItem item={topic} onNoAccessClick={onNoAccessClick} />
              </li>
            ))
          ) : (
            <li className={cl.lessons__lesson}>
              <CourseItem
                item={currentLessonBlock}
                onNoAccessClick={onNoAccessClick}
              />
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default MainInfoExtra;
